// extracted by mini-css-extract-plugin
module.exports = {"embedContainer":"EmbedPreview_embedContainer__2fhMs"};